import React from 'react';
import './LevelUpHome.css';
import JumbleImage from '../../Assets/jumble.webp';
import RoleplayImage from '../../Assets/role.webp';
import WordImage from '../../Assets/association.webp';
import { useNavigate } from 'react-router-dom';
import SEO from '../../SEO/SEO';
const LevelUpHome = () => {
  const navigate = useNavigate();

  return (
    <div className="levelup-container">
       <SEO
        title="English Learning Games | Boldly English"
        description="Improve your English vocabulary and communication skills with fun learning games, including Jumble Words, Role Play, and Word Association."
      canonical="https://boldlyenglish.com/levelup"
       />

      <h1 className="levelup-page-title">LEVEL UP YOURSELF</h1>

      <div className="card-grid">
        {/* Jumble Game */}
        <div className="game-card">
          <img src={JumbleImage} alt="Jumble Game" className="game-image" width={300} height={200} decoding="async" />
          <div className="game-content">
            <h2>Jumble Words</h2>
            <p>Unscramble letters to form words and boost your vocabulary! With fun puzzles across Beginner to Advanced levels, it's perfect for all ages.</p>
            <button onClick={() => navigate('/jumbleWordGame')}>Play</button>
          </div>
        </div>

        {/* Role Play */}
        <div className="game-card">
          <img src={RoleplayImage} alt="Role Play" className="game-image" width={300} height={200} loading="lazy" decoding="async" />
          <div className="game-content">
            <h2>Role Play</h2>
            <p>Become the hero of your own story! Choose your role, make decisions, and shape your adventure through interactive, real-life scenarios.</p>
            <button onClick={() => navigate('/roleplay')}>Play</button>
          </div>
        </div>

        {/* Word Association */}
        <div className="game-card">
          <img src={WordImage} alt="Word Association" className="game-image" width={300} height={200} loading="lazy" decoding="async" />
          <div className="game-content">
            <h2>Word Association</h2>
            <p>Match words, sharpen your mind, and grow your vocabulary with quick, fun challenges at every level! A fast, fun way to boost vocabulary.</p>
            <button onClick={() => navigate('/Wordgame')}>Play</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LevelUpHome;
